export default __webpack_public_path__ + "static/media/580.415445a8.png";